<template>
  <div class="tile is-parent">
    <article class="module-menu">
      <module-menu :type="1"></module-menu>
    </article>
    <article class="tile is-child">
      <template v-if='currentFashionMenu.moduleType == 0'>
        <hot-map></hot-map>
      </template>
      <template v-if='currentFashionMenu.moduleType == 1'>
        <sideslip></sideslip>
      </template>
      <template v-if='currentFashionMenu.moduleType == 2'>
        <carousel></carousel>
      </template>
      <template v-if ='currentFashionMenu.moduleType != 0 && currentFashionMenu.moduleType != 1 && currentFashionMenu.moduleType != 2'>
        <system-module></system-module>
      </template>
    </article>
  </div>
</template>

<script type="text/babel">
  import {mapState, mapActions} from 'vuex';
  import moduleMenu from '../fashionModuleMenu/main';
  import carousel from '../market/carousel/carousel';
  import sideslip from '../market/sideslip/main';
  import hotMap from '../market/hotMap/main'
  import systemModule from '../market/systemModule/main'

  export default {
    computed:{
      ...mapState({
        currentFashionMenu: state => state.currentFashionMenu
      })
    },
    components:{
      moduleMenu, carousel, hotMap, systemModule, sideslip
    },
    data(){
      return{
      }
    },
    attached() {

    },
    methods: {}
  }
</script>

<style lang="less" scoped>
  .module-menu {
    width: 200px;
    min-width: 200px;
    margin-right: 20px;
  }
</style>
